export default __webpack_public_path__ + "static/media/Captain's Legguards of the Battlements.814ee3c9.jpg";